import { CustomCard } from "../CustomCard/CustomCard";
import React from "react";
import {
  formatCurrency,
  renderStatusLabels,
  renderTravel,
} from "../../../utils/constants";
import { RenderCostsTable } from "./RenderCostsTable";
import { getTvaRatio } from "../../../utils/helpersFunction";

export const RenderCosts = ({
  cost,
  title,
  loading,
  prestationVue,
  prestation,
}) => {
  if (cost === null) {
    return null;
  }

  const renderLinesCost = (costs, costParams, params) => {
    return (
      <>
        {costs?.map(entry => {
          return (
            <div className={"row-price"}>
              <p>{entry.title}</p>

              <div className={"row-price-sub"}>
                <span className={"row-price-left"}>
                  {entry.type === "travel"
                    ? renderTravel(entry, costParams, params?.billing)
                    : entry.description
                        .split("\n")
                        .map((line, index, array) => (
                          <React.Fragment key={index}>
                            {line}
                            {index === array.length - 1 ? null : <br />}
                          </React.Fragment>
                        ))}
                </span>

                <span className={"row-price-right"}>
                  {formatCurrency(entry.amount)}
                </span>
              </div>
            </div>
          );
        })}
        {costs === undefined
          ? `Prestation: ${renderStatusLabels(
              prestation.status,
              prestation.subStatus,
            )}`
          : ""}
        <div className={"row-price-total"}>
          <div className={"row-price-sub"}>
            <span className={"row-price-left-total"}>
              Total net, TVA exclue
            </span>
            <span className={"row-price-right-total"}>
              {formatCurrency(costParams?.total)}
            </span>
          </div>
        </div>
        {costParams?.tvaAmount !== undefined &&
          costParams?.tvaAmount !== 0 && (
            <div>
              <div className={"row-price-sub"}>
                <span className={"row-price-left"}>
                  TVA {getTvaRatio(cost?.prestationsRef?.year) * 100}%{" "}
                </span>
                <span className={"row-price-right"}>
                  {formatCurrency(costParams?.tvaAmount)}
                </span>
              </div>
            </div>
          )}{" "}
        {costParams?.totalHorsTva !== undefined &&
          costParams?.totalHorsTva !== 0 && (
            <div>
              <div className={"row-price-sub"}>
                <span className={"row-price-left-total"}>
                  TOTAL, non-assujettis à la TVA{" "}
                </span>
                <span className={"row-price-right-total"}>
                  {formatCurrency(costParams?.totalHorsTva)}
                </span>
              </div>
            </div>
          )}{" "}
        {costParams?.roundCorrection !== 0 &&
        costParams?.roundCorrection !== undefined ? (
          <div>
            <div className={"row-price-sub"}>
              <span className={"row-price-left"}>Correction arrondi</span>
              <span className={"row-price-right"}>
                {formatCurrency(costParams?.roundCorrection)}
              </span>
            </div>
          </div>
        ) : null}
        {costParams?.isCancelInterprete !== undefined &&
          costParams?.isCancelInterprete === true && (
            <div>
              <div className={"row-price-sub"}>
                <span className={"row-price-left"}>
                  Prestation annulée sur absence du resp. d’entretien et/ou du bénéficiaire
                </span>
                <span className={"row-price-right"}></span>
              </div>
            </div>
          )}
        {costParams?.isCanceledClient !== undefined &&
          costParams?.isCanceledClient === true && (
            <div>
              <div className={"row-price-sub"}>
                <span className={"row-price-left"}>
                  {costParams.cancelSince >= 4 && costParams.cancelSince < 24
                    ? "Prestation annulée entre 24h et 4h avant"
                    : ""}
                  {costParams.cancelSince < 4
                    ? "Prestation annulée moins de 4 heures avant"
                    : ""}
                </span>
                <span className={"row-price-right"}></span>
              </div>
            </div>
          )}
        {costParams?.totalWithTva !== undefined &&
          costParams?.totalWithTva !== 0 && (
            <div className={"row-price-total"}>
              <div className={"row-price-sub"}>
                <span className={"row-price-left-total"}>
                  Montant TTC à payer{" "}
                </span>
                <span className={"row-price-right-total"}>
                  {formatCurrency(costParams?.totalWithTva)}
                </span>
              </div>
            </div>
          )}
      </>
    );
  };

  if (cost?.institution?.groupedBilling === true) {
    let item;
    let presta;

    if (prestationVue) {
      item = cost.costsMultiple.find(p => p.prestationId === prestation._id);
      presta = cost?.prestations?.find(p => p?._id === prestation?._id);
    }

    return (
      <>
        {!prestationVue && (
          <CustomCard
            title={"Total des coûts des prestations"}
            loading={loading}
          >
            {renderLinesCost(cost?.costs, cost?.costParams, {
              description: false,
              billing: cost?.institution?.defaultAddress,
            })}
          </CustomCard>
        )}
        <br />

        {!prestationVue ? (
          <RenderCostsTable cost={cost} />
        ) : (
          <CustomCard
            title={
              <>
                {title}
                {prestationVue === false ? ": N " + prestation.reference : ""}
              </>
            }
            loading={loading}
            style={{ marginBottom: 20 }}
          >
            {renderLinesCost(item?.cost, item?.costParams, {
              billing: presta?.billing,
            })}
          </CustomCard>
        )}
      </>
    );
  } else {
    let billing;

    if (prestationVue) {
      billing = prestation.billing;
    } else {
      billing = cost.prestations.length > 0 && cost.prestations[0].billing;
    }
    return (
      <CustomCard title={title} loading={loading}>
        {renderLinesCost(cost?.costs, cost?.costParams, {
          billing: billing,
        })}
      </CustomCard>
    );
  }
};
